export const isDarkTheme = (): boolean => {
    return document.body.getAttribute('data-bs-theme') === 'dark';
}